(function() {
  var canvas, ctx, snowflakes = [];
  var maxSnowflakes = 80;
  var snowflakeColors = ['#ffffff', '#e0e0e0'];

  function init() {
    canvas = document.createElement('canvas');
    canvas.id = 'snowfall-canvas';
    canvas.style.position = 'fixed';
    canvas.style.top = 0;
    canvas.style.left = 0;
    canvas.style.pointerEvents = 'none'; // Prevent it from blocking clicks
    canvas.style.zIndex = 9999; // Make sure the snow is on top
    document.body.appendChild(canvas);
    
    ctx = canvas.getContext('2d');
    resizeCanvas();

    for (var i = 0; i < maxSnowflakes; i++) {
      snowflakes.push(new Snowflake());
    }

    window.addEventListener('resize', resizeCanvas);
    requestAnimationFrame(updateSnowfall);
  }

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function Snowflake() {
    this.x = Math.random() * canvas.width;
    this.y = Math.random() * canvas.height;
    this.size = Math.random() * 4 + 3; // Snowflake size variation
    this.speed = Math.random() * 0.5 + 0.5;
    this.wind = Math.random() * 0.5 - 0.25;
    this.color = snowflakeColors[Math.floor(Math.random() * snowflakeColors.length)];
    this.rotation = Math.random() * Math.PI * 2; // Snowflake rotation for random effect
  }

  Snowflake.prototype.update = function() {
    this.x += this.wind;
    this.y += this.speed;
    if (this.y > canvas.height) {
      this.y = -this.size;
      this.x = Math.random() * canvas.width;
    }
  };

  Snowflake.prototype.draw = function() {
    ctx.save();
    ctx.translate(this.x, this.y);
    ctx.rotate(this.rotation); // Apply random rotation for variety
    ctx.beginPath();
    // Randomly create a simple "snowflake" with lines
    for (var i = 0; i < 6; i++) {
      ctx.moveTo(0, 0);
      ctx.lineTo(this.size * Math.cos((i * Math.PI) / 3), this.size * Math.sin((i * Math.PI) / 3));
    }
    ctx.strokeStyle = this.color;
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.restore();
  };

  function updateSnowfall() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    snowflakes.forEach(function(snowflake) {
      snowflake.update();
      snowflake.draw();
    });
    requestAnimationFrame(updateSnowfall);
  }

  init();
})();
